<template>
  <i class="font-icon" :class="[isElIcon ? icon : 'iconfont ' + icon]"></i>
</template>

<script>
export default {
  name: 'FontIcon',
  props: ['icon'],
  computed: {
    isElIcon() {
      return this.icon && this.icon.indexOf('el-icon') > -1;
    }
  }
}
</script>

<style lang="stylus" scoped>

</style>